<div class="wrapper mb-2">
  <div class="row">
    <div class="col-md-5 col-sm-12 text-left">
        <img src="./assets/icons/arrow.svg">
        <span class="label-title ml-2 mr-3"> Nova Recarga</span>
    </div>
    <div class="col-md-7 col-sm-12 p-0">
        <div class="row container-fluid menu-navegacao-borda m-0 bg-white">
            <div class="menu-navegacao-espacamento col d-flex align-items-center">
                <span class="menu-navegacao-icone"></span>
                <span class="menu-navegacao-texto select">PRODUTOS</span>
                <span class="menu-navegacao-seta"></span>
            </div>
            <div class="menu-navegacao-espacamento d-flex align-items-center">
                <span class="menu-navegacao-icone"></span>
                <span class="menu-navegacao-texto select">FAVORECIDOS</span>
                <span class="menu-navegacao-seta"></span>
            </div>
            <div class="menu-navegacao-espacamento d-flex align-items-center">
                <span class="menu-navegacao-icone"></span>
                <span class="menu-navegacao-texto">CRÉDITO</span>
                <span class="menu-navegacao-seta"></span>
            </div>
            <div class="menu-navegacao-espacamento d-flex align-items-center">
                <span class="menu-navegacao-icone"></span>
                <span class="menu-navegacao-texto">CONFIRMAÇÃO</span>
                <span class="menu-navegacao-seta"></span>
            </div>
            <div class="menu-navegacao-espacamento d-flex align-items-center">
                <span class="menu-navegacao-icone"></span>
                <span class="menu-navegacao-texto">PAGAMENTO</span>
            </div>
        </div>
    </div>

      <div class="component-box container-fluid bg-white">
          <div class="container-fluid mb-5">
              <div class="row">
                  <div class="col-lg-12 col-md-12 col-sm-12 text-left mt-5 mb-1">
                      <div class="row button-container mb-3">
                          <div class="col-5 text-left component-title">Selecione os Favorecidos Ativos</div>
                          <div class="col-7 text-right">
                              <!--<button type="submit" class="custom-button-white" (click)="savePedido()">SALVAR</button>-->
                              <button type="submit" class="custom-button-back" (click)="previous()">Voltar</button>
                              <button type="submit" class="custom-button-full" (click)="next()">Continuar</button>
                          </div>
                      </div>

                      <div class="row">
                          <div class="col-lg-12 col-md-12 col-sm-12">
                              <p class="component-subtitle color text-left"> {{count}} de {{totalColaboradores}} favorecidos selecionados
                              </p>
                          </div>
                      </div>

                  </div>
              </div>
          </div>
              <div class="row">
          <div class="container-fluid">
                  <!--
                      Funcionalidade desativada em 03/09 -> https://app.asana.com/0/994556555396601/1192231162085265
                      Aguardando refatoração
                      <div class="text-right">
                          <div class="col-lg-12 col-md-12 col-sm-12 my-2">
                              <button type="button" class="list-header-button" (click)="newColaborador()">
                                  <img class="list-header-icon" src="./assets/icons/user-purple.png" />
                                  NOVO FAVORECIDO
                              </button>
                              <button type="button" class="list-header-button" (click)="showModal(modalColaboradorEsporadico)">
                                  <img class="list-header-icon" src="./assets/icons/user-purple.png" />
                                  FAVORECIDO ESPORÁDICO
                              </button>
                          </div>
                      </div>
                  -->
                  <div class="col-lg-2 col-md-2 col-sm-12">
                      <div class="list-select-all mr-4 my-1" [ngClass]="{'active': count > 0}"><img [src]="(count> 0) ?
            '/assets/icons/check-purple.png':'/assets/icons/check-grey.png'" width="auto" height="20px" /> <span class="mx-2" (click)="selectAll(selectAllItem= !selectAllItem);">Selecionar
              tudo</span>
                      </div>
                  </div>
                  <div class="col-lg-2 col-md-2 col-sm-12" style="max-inline-size: max-content;">
                    <button type="button" class="list-header-filter-button" style="margin-right: 5px;" (click)="showFilter(filtro)"><img
                        class="list-header-icon-filter" src="./assets/icons/filter-tool.png" />
                        Aplicar filtro
                    </button>
                    <button type="button" class="list-header-remove-filter-button" (click)="removerFilter()"><img
                        class="list-header-icon-filter" src="./assets/icons/garbage-grey.png" />
                        Remover filtro
                    </button>
                  </div>
                  <div class="col-lg-5 col-md-5 col-sm-12">
                      <div class="row h-100">
                            <div class="list-show-item ml-auto">Mostrar:
                                <select [(ngModel)]="showItem">
                                    <option [ngValue]="10" value="10" selected>10</option>
                                    <option [ngValue]="25" value="25">25</option>
                                    <option [ngValue]="50" value="50">50</option>
                                    <option [ngValue]=100 value="100">100</option>
                                </select>
                            </div>
                          <div class="list-pagination ml-auto">
                              <pagination-controls (pageChange)="currentPage= $event" responsive="true" previousLabel="" nextLabel="">
                              </pagination-controls>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
          <hr />
          <!--            Listagem -->
          <div class="table-responsive">
              <table class="list-table table table-striped">
                  <thead class="list-table-head">
                      <th></th>
                      <th class="" colspan="2" (click)="sortOrder= !sortOrder; orderBy('nome',
            sortOrder)">Nome</th>
                      <th class="" (click)="sortOrder= !sortOrder; orderBy('documento',
            sortOrder)">CPF</th>
                      <th class="" (click)="sortOrder= !sortOrder; orderBy('matricula',
            sortOrder)">Matrícula</th>
                      <th class="" (click)="sortOrder= !sortOrder;
            orderBy('nomeCentroCusto', sortOrder)">Centro de Custo
                      </th>
                      <th class="" (click)="sortOrder= !sortOrder; orderBy('nomeUnidade',
            sortOrder)">Unidade</th>
                      <th class="" (click)="sortOrder= !sortOrder;
            orderBy('nomeDepartamento', sortOrder)">
                          Departamento
                      </th>
                      <th class="text-center" (click)="sortOrder= !sortOrder;
            orderBy('statusApp', sortOrder)">
                          Favorecido apto?
                      </th>
                  </thead>
                  <tbody class="list-table-row">
                      <tr *ngFor="let listColaborador of colaboradores | paginate:
                {itemsPerPage: showItem, currentPage: currentPage } |
                modalFilterColaborador: filtroPesquisa: '' : filtroNome : filtroCPF
                : filtroMatricula : filtroCentroCustoSelectedItems :
                filtroUnidadeSelectedItems : filtroDepartamentoSelectedItems: '':
                alterado" class="list-table-cell" class="clickable" (click)="listColaborador.selected = !listColaborador.selected;
            updateCount()">
                          <td>
                              <span>
                <input [attr.id]="listColaborador.id" type="checkbox" class="radio-checkbox"
                  [(ngModel)]="listColaborador.selected" (click)="listColaborador.selected=
                  !listColaborador.selected; updateCount();" />
                <label [attr.for]="listColaborador.id" class="radio-label"></label>
              </span>
                          </td>
                          <td colspan="2">{{listColaborador.name}} </td>
                            <td>
                                <span *ngIf="listColaborador.document || listColaborador.document != null">{{ listColaborador.document | cpf }}</span>
                                <span *ngIf="!listColaborador.document || listColaborador.document == null"></span>
                            </td>

                            <td>{{listColaborador.registry}}</td>
                            <td>
                                <span *ngIf="listColaborador.costCenter">{{listColaborador.costCenter}}</span>
                            </td>
                            <td>
                                <span *ngIf="listColaborador.unity">{{listColaborador.unity}}</span>
                            </td>
                            <td>
                                <span *ngIf="listColaborador.department">{{listColaborador.department}}</span>
                            </td>
                            <td class="text-center">
                                <span *ngIf="(!listColaborador.hasCard && listColaborador.hasApp)" data-bs-toggle="tooltip" title="Já possui aplicativo">
                                    <img class="img-status" src="./assets/icons/status-green.png" />
                                </span>
                                <span *ngIf="(listColaborador.hasCard && !listColaborador.hasApp)" data-bs-toggle="tooltip" title="Já possui cartão">
                                    <img class="img-status" src="./assets/icons/status-green.png" />
                                </span>
                                <span *ngIf="(listColaborador.hasCard && listColaborador.hasApp)" data-bs-toggle="tooltip" title="Já possui aplicativo e cartão">
                                    <img class="img-status" src="./assets/icons/status-green.png" />
                                </span>
                                <span *ngIf="!listColaborador.hasApp && !listColaborador.hasCard">
                                    <img class="img-status" src="./assets/icons/status-yellow.png" data-bs-toggle="tooltip" title="Não possui aplicativo ou cartão"/>
                                </span>
                            </td>
                      </tr>
                  </tbody>
              </table>
          </div>
          <div *ngIf="colaboradorSelect === false">
              <span class="text-danger">Selecione ao menos um favorecido.</span>
          </div>
          <hr />

          <div class="container-fluid">
              <div class="row">
                  <div class="col-lg-6 col-md-6 col-sm-12 text-right">
                      <div class="list-pagination ml-auto">
                          <pagination-controls (pageChange)="currentPage= $event" responsive="true" previousLabel="" nextLabel="">
                          </pagination-controls>
                      </div>
                  </div>
                  <div class="col-lg-6 col-md-6 col-sm-12 component-subtitle">
                      <p class="component-subtitle color text-right">{{count}} de {{totalColaboradores}} favorecidos selecionados
                      </p>
                  </div>
              </div>
              <div class="container-fluid mt-3 mb-3">
                  <div class="row">
                      <div class="col text-right">
                          <!--<button type="submit" class="custom-button-white" (click)="savePedido()">SALVAR</button>-->
                          <button type="submit" class="custom-button-back" (click)="previous()">Voltar</button>
                          <button type="submit" class="custom-button-full" (click)="next()">Continuar</button>
                      </div>
                  </div>
              </div>
          </div>
      </div>
  </div>
</div>


<!--Modal do Filtro-->
<ng-template #filtro let-modal>
  <div class="col-12 modal-header clean-modal-header">
        <div class="col-md-12">
            <h5 class="clean-modal-title">Aplicar filtro</h5>
        </div>
    </div>
    <div class="row col-12 clean-modal-content">
        <div class="col-lg-4 col-md-6 col-sm-12 my-4">
            <div class="custom-filter-input-container">
                <mat-form-field>
                    <mat-label>Nome</mat-label>
                    <input [formControl]="nameCtrl" matInput type="text" [(ngModel)]="filtroNome" id="name">
                    <button mat-button *ngIf="filtroNome" matSuffix mat-icon-button aria-label="Clear" (click)="filtroNome=''">
                        <mat-icon>close</mat-icon>
                    </button>
                </mat-form-field>
            </div>
        </div>
        <div class="col-lg-4 col-md-6 col-sm-12 my-4">
            <mat-form-field>
                <mat-label>CPF</mat-label>
                <input [formControl]="cpfCtrl" matInput type="text" [(ngModel)]="filtroCPF" id="cpf">
                <button mat-button *ngIf="filtroCPF" matSuffix mat-icon-button aria-label="Clear" (click)="filtroCPF=''">
                    <mat-icon>close</mat-icon>
                </button>
            </mat-form-field>
        </div>
        <div class="col-lg-4 col-md-6 col-sm-12 my-4">
            <mat-form-field>
                <mat-label>Matrícula</mat-label>
                <input [formControl]="registerCtrl" matInput type="text" [(ngModel)]="filtroMatricula" id="register">
                <button mat-button *ngIf="filtroMatricula" matSuffix mat-icon-button aria-label="Clear" (click)="filtroMatricula=''">
                    <mat-icon>close</mat-icon>
                </button>
            </mat-form-field>
        </div>

        <div class="col-lg-4 col-md-6 col-sm-12 my-4">
            <div class="custom-filter-input-container">
                <mat-form-field>
                    <mat-label>Centro de Custo</mat-label>
                    <mat-select [formControl]="costCenterCtrl" multiple>
                        <mat-option *ngFor="let item of filtroCentroCustoDropDownList" [value]="item.ITEM_ID">{{item.ITEM_TEXT}}</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </div>

        <div class="col-lg-4 col-md-6 col-sm-12 my-4">
            <div class="custom-filter-input-container">
                <mat-form-field>
                    <mat-label>Unidade</mat-label>
                    <mat-select [formControl]="unitCtrl" multiple>
                        <mat-option *ngFor="let item of filtroUnidadeDropDownList" [value]="item.ITEM_ID">{{item.ITEM_TEXT}}</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </div>

        <div class="col-lg-4 col-md-6 col-sm-12 my-4">
            <div class="custom-input-container">
                <mat-form-field>
                    <mat-label>Departamento</mat-label>
                    <mat-select [formControl]="departmentCtrl" multiple>
                        <mat-option *ngFor="let item of filtroDepartamentoDropDownList" [value]="item.ITEM_ID">{{item.ITEM_TEXT}}</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </div>
    </div>
    <div class="col-12 clean-modal-footer">
        <button class="custom-filter-button custom-filter-button-just" type="button" (click)="applyFilter();modal.dismiss('Close click')" ngbAutofocus>
            Aplicar
        </button>
    </div>
</ng-template>


<!-- Modal favorecido Esporádico -->
<ng-template #modalColaboradorEsporadico let-modal>
  <div class="container-fluid mb-5 mt-5">
      <div class="row mx-5">
          <div class="col">
              <input class="list-header-search-input w-100" type="search" placeholder="Pesquise aqui..." [(ngModel)]="filtroPesquisaSporadic" />
          </div>
      </div>

      <hr />
      <div class="table-responsive">
          <table class="list-table table table-striped">
              <thead class="list-table-head">
                  <th></th>
                  <th class="" colspan="2" (click)="sortOrder= !sortOrder; orderBy('nome',
          sortOrder)">Nome</th>
                  <th class="" (click)="sortOrder= !sortOrder; orderBy('documento',
          sortOrder)">CPF</th>
                  <th class="" (click)="sortOrder= !sortOrder; orderBy('matricula',
          sortOrder)">Matricula</th>
                  <th class="" (click)="sortOrder= !sortOrder;
          orderBy('nomeCentroCusto', sortOrder)">Centro de Custo
                  </th>
                  <th class="" (click)="sortOrder= !sortOrder; orderBy('nomeUnidade',
          sortOrder)">Unidade</th>
                  <th class="" (click)="sortOrder= !sortOrder;
          orderBy('nomeDepartamento', sortOrder)">
                      Departamento
                  </th>
                  <th class="text-center" (click)="sortOrder= !sortOrder;
          orderBy('statusApp', sortOrder)">
                      Aplicativo
                  </th>
              </thead>
              <tbody class="list-table-row">
                  <tr *ngFor="let listColaborador of colaboradores | paginate: {id:
              'paginationModal', itemsPerPage: 5, currentPage: currentPageModal } |
              modalFilterColaborador: filtroPesquisaSporadic"
            class="list-table-cell" class="clickable" (click)="listColaborador.esporadico= !listColaborador.esporadico;
            updateCount();">

                      <td>
                          <span>
              <input [attr.id]="listColaborador.id" type="checkbox" class="radio-checkbox"
                [(ngModel)]="listColaborador.esporadico" (click)="listColaborador.esporadico=
                !listColaborador.esporadico;
                updateCount();" />
              <label [attr.for]="listColaborador.id" class="radio-label"></label>
            </span>
                      </td>
                      <td colspan="2">{{listColaborador.nome}}</td>
                      <td>{{listColaborador.documento}}</td>
                      <td>{{listColaborador.matricula}}</td>
                      <td>
                          <span *ngIf="listColaborador.centroCusto">{{listColaborador.centroCusto}}</span>
                      </td>
                      <td>
                          <span *ngIf="listColaborador.unidade">{{listColaborador.unidade}}</span>
                      </td>
                      <td>
                          <span *ngIf="listColaborador.departamento">{{listColaborador.departamento}}</span>
                      </td>
                      <td class="text-center">
                          <span *ngIf="listColaborador.termoUso"><img class="img-status"
                src="./assets/icons/status-green.png" /> </span>
                          <span *ngIf="!listColaborador.termoUso"><img class="img-status"
                src="./assets/icons/status-yellow.png" /> </span>
                      </td>
                  </tr>
              </tbody>
          </table>
      </div>
      <hr />
      <div class="col text-center">
          <div class="list-pagination ml-auto">
              <pagination-controls id="paginationModal" (pageChange)="currentPageModal=
        $event" responsive="true" previousLabel="" nextLabel=""></pagination-controls>
          </div>
      </div>
      <div class="col-12 text-right">
          <button class="custom-button-full" type="button" (click)="modal.dismiss('Close click');">
      OK
    </button>
      </div>
  </div>
</ng-template>

<ng-template #noSelectColaborador let-modal>
    <div class="col-12 modal-header clean-modal-header">
        <div class="col-md-12">
            <h5 class="clean-modal-title">Selecione ao menos 1 favorecido para processeguir.</h5>
        </div>
    </div>
    <div class="col-12 clean-modal-footer text-center">
        <button class="custom-filter-button custom-filter-button-just" type="button"
            (click)="modal.dismiss('Close click')">
            OK
        </button>
    </div>
</ng-template>

<ng-template #noColaborador let-modal>
    <div class="col-12 modal-header clean-modal-header">
        <div class="col-md-12">
            <h5 class="clean-modal-title">Não existe favorecido associado a esse produto.</h5>
        </div>
    </div>
    <div class="col-12 clean-modal-footer text-center">
        <button class="custom-filter-button custom-filter-button-just" type="button"
            (click)="navigateToColaborador();modal.dismiss('Close click')" style="background-position: 95% 50%;">
            Clique aqui para cadastrar um favorecido a esse produto.
        </button>
    </div>
</ng-template>
